import { render, staticRenderFns } from "./NavigationMailbox.vue?vue&type=template&id=3a084277&"
import script from "./NavigationMailbox.vue?vue&type=script&lang=js&"
export * from "./NavigationMailbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports